module.exports = require("../vinyl/inherits.js");